import type { WindowState } from '../../types';
import { TerminalApp } from '../Terminal/TerminalApp';
import { FileManagerApp } from '../FileManager/FileManagerApp';
import { ProjectsApp } from '../ProjectManager/ProjectsApp';
import { CodeEditorApp } from '../CodeEditor/CodeEditorApp';
import { BrowserApp } from '../Browser/BrowserApp';
import { ChatApp } from '../Chat/ChatApp';
import { SettingsApp } from '../Settings/SettingsApp';
import { PreviewApp } from '../Browser/PreviewApp';
import { CalculatorApp } from '../Calculator/CalculatorApp';
import { MinesweeperApp } from '../Games/MinesweeperApp';

export function WindowContent({ window }: { window: WindowState }) {
  switch (window.appType) {
    case 'terminal':
      return <TerminalApp key={window.id} {...window.props} />;
    case 'file-manager':
      return <FileManagerApp key={window.id} {...window.props} />;
    case 'projects':
      return <ProjectsApp key={window.id} {...window.props} />;
    case 'editor':
      return <CodeEditorApp key={window.id} {...window.props} />;
    case 'browser':
      return <BrowserApp key={window.id} {...window.props} />;
    case 'chat':
      return <ChatApp key={window.id} {...window.props} />;
    case 'settings':
      return <SettingsApp key={window.id} {...window.props} />;
    case 'preview':
      return <PreviewApp key={window.id} {...window.props} />;
    case 'calculator':
      return <CalculatorApp key={window.id} />;
    case 'minesweeper':
      return <MinesweeperApp key={window.id} />;
    default:
      return <div>Unknown app</div>;
  }
}